export const calculateAmount = (
  categoriePremium,
  nbrPhotos,
  boost = 0,
) => {
  let newAmount = 2000;
  if (boost == 3) {
    return 1000;
  }
  if (nbrPhotos <= 2) {
    newAmount = categoriePremium ? 4000 : 2000;
  } else {
    newAmount = categoriePremium ? 10000 : 5000;
  }
  return newAmount;
};
